import {
  Button,
  Collapse,
  HStack,
  Spacer,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React, { useEffect } from 'react';
import { RemirrorJSON } from 'remirror';
import { PublishDialog, PublishDialogProps } from './PublishDialog';

interface PublishBarProps
  extends Omit<
    PublishDialogProps,
    'isPublishing' | 'title' | 'isOpen' | 'onClose' | 'onMessageChange'
  > {
  nodeId: string;
  isPublished?: boolean;
  isPublishing?: boolean;
  onPublish(announcementMessage?: RemirrorJSON): void;
  confirmationTitle: string;
  confirmationContent: React.ReactNode;
}

export const PublishBar = ({
  nodeId,
  isPublishing,
  isPublished,
  onPublish,
  confirmationTitle,
  confirmationContent,
  ...formProps
}: PublishBarProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (isPublished && isOpen) {
      onClose();
    }
  }, [isPublished, isOpen, onClose]);

  return (
    <>
      <Collapse in={!isPublished} unmountOnExit>
        <HStack
          color={useColorModeValue('gray.800', 'gray.50')}
          bg={useColorModeValue('blue.50', 'blue.900')}
          p={3}
          spacing={0}
        >
          <Text>{t`Draft only visible to you.`}</Text>
          <Spacer />
          <Button colorScheme="blue" isLoading={isPublishing} onClick={onOpen}>
            {t`Publish`}
          </Button>
        </HStack>
      </Collapse>
      <PublishDialog
        nodeId={nodeId}
        isOpen={isOpen}
        onClose={onClose}
        title={confirmationTitle}
        isPublishing={!!isPublishing}
        onPublish={onPublish}
        {...formProps}
      >
        {confirmationContent}
      </PublishDialog>
    </>
  );
};
